

import { Action } from '@ngrx/store';
import { BeforeStart } from '../../model/ngrx/before-start.model';
import * as LogoutActions from './../actions/logout.actions';

export function clearState(reducer) {
    return function (state, action) {

        if (action.type === LogoutActions.ActionTypes.LOGOUT) {
            state = undefined;
        }

        return reducer(state, action);
    };
}
